export default function sparkMD5() {
  return import(
    /* webpackChunkName: "spark-md5" */
    'spark-md5'
  );
}

